import { Component, Input } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-custom-field',
  templateUrl: './custom-field.component.html',
  styleUrls: ['./custom-field.component.css']
})
export class CustomFieldComponent {
  @Input() form !: FormGroup;
  @Input() name !: string | number;
  @Input() useLabelInErrorText: boolean = true;
  @Input() customLabel !: string;
  @Input() label!: string;
  @Input() nolabel: boolean = false;
  @Input() custom!: boolean;
  @Input() containerClass: string = '';
  @Input() class: string = '';
  @Input() errt: string = ''
  @Input() taller: boolean = false;
  @Input() required: boolean = false;
  @Input() min: any;
  @Input() max: any;
  @Input() helpText: string = '';
  @Input() pattern: string = '';

  isRequired () {
    if (this.form.controls[this.name]) {
      return this.form.controls[this.name].hasValidator(Validators.required)
    } else {
      return false;
    }
  }
}
